import globalMU from "globalMU";
import React from "react";
import { useFormik } from "formik";
import { Paginacao } from "app/components/itens-orcamento/paginacao/Paginacao";
import Legenda from "app/components/itens-orcamento/legenda/Legenda";
import { InputData } from "app/components/inputs/InputData";

const estiloInputs = require('../../../../estilos/inputs.module.scss').default
const estiloOrcamentoEmAberto = require("../pendencia-cliente.module.scss").default;

const estiloTabela = require('../../../../estilos/tabelas.module.scss').default

export type DadosOrcamentoEmAberto = {
    "TotalRecords": number,
    "RowNumber": number,
    "Numero": number,
    "Filial"?: string, // 450570
    "DataCriacao": Date,
    "NomeVendedor": string,
    "Valor": number,
    "DataValidade": Date,
    "NomeCliente"?: string,
    "NomeFilial"?: string,
    "Vencido": boolean,
    "RowsCount": number,
    "UserMessage"?: string,
    "Transforming": false
}

export type OrcamentoEmAbertoForm = {
    CodigoCliente: number
    CodigoFilial: string
    DataFinal: string
    DataInicial: string
    NumeroPagina: number
    TamanhoPagina: number
    Transforming: false
    UserMessage?: string
}

export type OrcamentoEmAbertoProps = {
    dados: DadosOrcamentoEmAberto[];
    valoresFormulario: OrcamentoEmAbertoForm;
    processando?: boolean;
    onFiltrar: (values: OrcamentoEmAbertoForm) => void
    pageCount: number,
    paginaAtual: number
    onAlterarPagina: (filtros: OrcamentoEmAbertoForm) => void;
    onChangeSenha: (senha: string) => void
    exibirSenha: boolean
};

export const OrcamentoEmAberto = (props: OrcamentoEmAbertoProps) => {

    const legendaOrcamentosEmAberto = <section >
        <Legenda itens={[
            {
                nome: "Vencido",
                cor: "#fc0"
            },
        ]} />
    </section>

    const tabelaOrcamentosEmAberto =
        <div className={estiloTabela.containerRolavel}>
            <table 
                id="Cliente_OrcamentosEmAberto_Pedidos" 
                key="Cliente_OrcamentosEmAberto_Pedidos"
                className={`_table _w-full _border-collapse text-right ${estiloTabela.tabela}`}>
                <thead>
                    <tr className={estiloTabela.cabecalhoTexto}>
                        <th className={estiloTabela.cabecalhoTexto}>Número Pedido</th>
                        <th className={estiloTabela.cabecalhoTexto}>Filial</th>
                        <th className={estiloTabela.cabecalhoTexto}>Data</th>
                        <th className={estiloTabela.cabecalhoNumerico}>Valor</th>
                        <th className={estiloTabela.cabecalhoTexto}>Vendedor</th>
                    </tr>
                </thead>
                <tbody>
                    {props.dados?.map((dado) => {
                        return (
                            <tr className={`_table-row ${estiloTabela.dadoTexto} ${estiloTabela.linhaClicavel} $={estiloTabela.dadoTexto}`} 
                                key={dado.Numero.toString()}
                                id={`Cliente_OrcamentosEmAberto_Pedidos_Linha_${dado.RowNumber}`}
                            >
                                <td style={{ whiteSpace: "nowrap", boxShadow: dado.Vencido ? "4px 0 #fc0 inset" : " " }}
                                    id={`Cliente_OrcamentosEmAberto_Pedidos_NumPed_Linha_${dado.RowNumber}`}
                                    key={`Cliente_OrcamentosEmAberto_Pedidos_NumPed_Linha_${dado.RowNumber}`}
                                >{dado.Numero}</td>
                                <td style={{ maxWidth: "30px"}}
                                    id={`Cliente_OrcamentosEmAberto_Pedidos_Filial_Linha_${dado.RowNumber}`}
                                    key={`Cliente_OrcamentosEmAberto_Pedidos_Filial_Linha_${dado.RowNumber}`}
                                    title={dado.NomeFilial}
                                >
                                    {dado.Filial}
                                    </td>
                                <td 
                                    id={`Cliente_OrcamentosEmAberto_Pedidos_DataCriacao_Linha_${dado.RowNumber}`}
                                    key={`Cliente_OrcamentosEmAberto_Pedidos_DataCriacao_Linha_${dado.RowNumber}`}
                                >{globalMU.formatDate(dado.DataCriacao)}</td>
                                <td className={estiloTabela.dadoNumerico}
                                    id={`Cliente_OrcamentosEmAberto_Pedidos_Valor_Linha_${dado.RowNumber}`}
                                    key={`Cliente_OrcamentosEmAberto_Pedidos_Valor_Linha_${dado.RowNumber}`}
                                >{globalMU.formatarValorNumerico(dado.Valor, 2, true)}</td>
                                <td 
                                    id={`Cliente_OrcamentosEmAberto_Pedidos_NomeVendedor_Linha_${dado.RowNumber}`}
                                    key={`Cliente_OrcamentosEmAberto_Pedidos_NomeVendedor_Linha_${dado.RowNumber}`}
                                >{dado.NomeVendedor}</td>
                            </tr>
                        );
                    })
                    }
                </tbody>
            </table>
        </div>

    const formik = useFormik({
        initialValues: props.valoresFormulario,
        onSubmit: (values, { }) => { },
        enableReinitialize: true,
    });


    return (
        <>
            <div className={estiloOrcamentoEmAberto.form}>
                <label>Data inicial</label>
                <div>
                    <InputData
                        data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataInicial)}
                        id="Cliente_OrcamentosEmAberto_DataInicial"
                        key="Cliente_OrcamentosEmAberto_DataInicial"
                        disabled={props.processando}
                        onChange={e => formik.setFieldValue("DataInicial", e)}
                        selecionaValorOnFocus
                    />
                </div>

                <label>Data final</label>
                <div>
                    <InputData
                        data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataFinal)}
                        key="Cliente_OrcamentosEmAberto_DataFinal"
                        id="Cliente_OrcamentosEmAberto_DataFinal"
                        disabled={props.processando}
                        onChange={e => formik.setFieldValue("DataFinal", e)}
                        selecionaValorOnFocus
                    />
                </div>
            </div>
            <button
                onClick={() => {
                    props.onFiltrar(formik.values);
                }}
                className={estiloOrcamentoEmAberto.button}
                id="Cliente_OrcamentosEmAberto_BotaoFiltrar"
                key="Cliente_OrcamentosEmAberto_BotaoFiltrar"
                disabled={props.processando}
                style={{ marginLeft: "8px" }}
            >
                Filtrar
            </button>
            <div className={estiloOrcamentoEmAberto.separador} />
            {tabelaOrcamentosEmAberto}
            {props.pageCount > 1 &&
            <Paginacao
                paginaAtual={props.paginaAtual}
                totalPaginas={props.pageCount}
                id="Cliente_OrcamentosEmAberto_Paginacao"
                key="Cliente_OrcamentosEmAberto_Paginacao"
                onAlterarListaSelecionada={(page) => {
                    props.onAlterarPagina({
                        ...formik.values,
                        NumeroPagina: page
                    })
                }}
            />
            }
            {legendaOrcamentosEmAberto}
            {props.exibirSenha && (
                <div className={estiloOrcamentoEmAberto.form}>
                    <label className={estiloInputs.labelObrigatorio}>Senha</label>
                    <div>
                        <input
                            type="password"
                            id="OrcamentoEmAberto_CampoSenha"
                            key="OrcamentoEmAberto_CampoSenha"
                            disabled={props.processando}
                            autoFocus
                            autoComplete="off"
                            aria-autocomplete="none"
                            onChange={(e) => props.onChangeSenha(e.target.value)}
                        />
                    </div>
                </div>
            )}

        </>
    )
}
